<div *ngIf="deliveryOrderDetails" class="chat-container">
	<div class="chat-header">
		<h4 class="chat-title">
			<mat-icon class="chat-icon">chat</mat-icon>
			Driver and Customer Messages
		</h4>
	</div>

	<div *ngIf="!showChat" class="no-messages-container">
		<mat-icon class="no-messages-icon">chat_bubble_outline</mat-icon>
		<p class="no-messages-text">No messages available</p>
		<p class="no-messages-subtitle">Messages will appear here when the driver and customer communicate</p>
	</div>

	<div *ngIf="showChat" class="chat-messages">
		<div *ngFor="let message of messages; trackBy: trackByMessage" 
			 class="message-wrapper"
			 [ngClass]="{
				'rider-message': isRiderMessage(message),
				'customer-message': isCustomerMessage(message),
				'system-message': isSystemMessage(message)
			 }">
			
			<!-- Rider Message (Left side) -->
			<div *ngIf="isRiderMessage(message)" class="message-container rider-message-container">
				<div class="message-bubble rider-bubble">
					<div class="message-content">
						<div class="message-sender">{{ getMessageSenderName(message) }}</div>
						<div class="message-text">{{ message.Message }}</div>
					</div>
				</div>
				<div class="message-time rider-time">{{ message.CreatedAt | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>

			<!-- Customer Message (Right side) -->
			<div *ngIf="isCustomerMessage(message)" class="message-container customer-message-container">
				<div class="message-bubble customer-bubble">
					<div class="message-content">
						<div class="message-sender">{{ getMessageSenderName(message) }}</div>
						<div class="message-text">{{ message.Message }}</div>
					</div>
				</div>
				<div class="message-time customer-time">{{ message.CreatedAt | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>

			<!-- System Message (Center) -->
			<div *ngIf="isSystemMessage(message)" class="message-container system-message-container">
				<div class="message-bubble system-bubble">
					<div class="message-content">
						<div class="message-text">{{ message.Message }}</div>
					</div>
				</div>
				<div class="message-time system-time">{{ message.CreatedAt | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>
		</div>
	</div>
</div>
